import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/evergreen/MainEvergreen.webp"; 

import Farmers from "../../../assets/img/blog/evergreen/Farmers.webp"; 
import Garden from "../../../assets/img/blog/evergreen/Garden.webp"; 
import Nights from "../../../assets/img/blog/evergreen/Nights.webp"; 
import Public from "../../../assets/img/blog/evergreen/Public.webp"; 

const MAPLE_SECTIONS = [
  {
    farms: [
      {
        name: "1. Saturday Farmers Market",
        img: Farmers,
        subTitle: "SaturdayFarmersMarket_IndoorMarket",
        description: "Since 2007, Evergreen’s Saturday Farmers Market has been a beloved community hub, starting with just 25 local vendors and growing to become the largest farmers market in Toronto! Now, open year-round, snow or shine, we’re indoors for the winter. Come shop fresh local Ontario produce, seasonal fruits and veggies, jams, meats, kombucha, baked goods, and more!",
        location: "CRH Gallery, Evergreen Brick Works",
        website: "Saturday Farmers Market",
        webUrl: "https://www.evergreen.ca/evergreen-brick-works/markets-food/saturday-farmers-market/", // Using a generic evergreen link if not specific
        details: [
          { label: "When", value: "Every Saturdays" },
          { label: "Time", value: "9:00 AM - 1:00 PM" },
          { label: "Important Notes", value: "Open year-round, outdoors from May to October and indoors from November to April. | Bring your own containers or borrow Muuse cups and containers for free at the market." }
        ]
      },
      {
        name: "2. Free Public Skate",
        img: Public,
        subTitle: "skating in farm",
        description: "Whether you’re skating with family, meeting friends, or connecting with new faces, it’s the perfect way to get outside, stay active, and enjoy the winter season. Skate under the beams of a historic brick factory—an experience you won’t want to miss!",
        location: "Evergreen Brick Works",
        website: "Free Public Skate",
        webUrl: "https://www.evergreen.ca/evergreen-brick-works/skating/",
        details: [
          { label: "When", value: "Every Saturaday & Sunday (January & February)" },
          { label: "Time", value: "1 PM – 5:00 PM" },
          { label: "Important Notes", value: "A CSA-approved helmet is mandatory for skaters aged 6 and under. Helmet rentals are free of charge. | Skates must be worn on the ice. You can bring your own or rent from us for a suggested $5 fee (proceeds support free programming). | Please dress warmly, as our rink has an open roof!" }
        ]
      },
      {
        name: "3. DJ Skate Nights",
        img: Nights,
        subTitle: "DJ Skate Night is BACK",
        description: "Join us for the 2nd Annual DJ Skate Nights—where Toronto’s most scenic skating rink transforms into the coolest winter hangout in town!",
        location: "Evergreen Brick Works",
        website: "DJ Skate Nights",
        webUrl: "https://www.evergreen.ca/evergreen-brick-works/skating/dj-skate-nights/",
        details: [
          { label: "When", value: "Every Saturdays (January & February)" },
          { label: "Time", value: "6:00 PM – 9:00 PM" },
          { label: "Cost", value: "PWYC (suggested $5 per person)" },
          { label: "What's included", value: "✨ Skate under the trees while our DJ spins your favorite tunes! | 🍴 Food vendors | 🔥 Firepits | 🍫 DIY S’more Kits | 🏺 Artisan Mini-Market | 🎮 Giant Games" },
          { label: "Important Notes", value: "Only TipTap payments are accepted; no cash at the door." },
        ]
      },
      {
        name: "4. Evergreen Garden Market",
        img: Garden,
        subTitle: "market",
        description: "The Evergreen Garden Market combines a classic general store, a contemporary gift shop, and a sustainable garden center. It features local small-batch products, handmade ceramics, foraged teas, gardening books, and more. Perfect for unique gifts!",
        location: "Evergreen Brick Works",
        website: "Evergreen Garden Market",
        webUrl: "https://www.evergreen.ca/evergreen-garden-market/",
        details: [
            { label: "When", value: "Everyday" },
            { label: "Hours of Operation", value: "Monday - Friday: 10:00 am – 5:00 pm | Saturday: 9:00 am – 5:00 pm | Sunday: 10:00 am – 5:00 pm" },
            { label: "Important Notes", value: "Explore Toronto’s largest selection of Ontario Native plants, along with gardening essentials like compost, pots, tools, soil amendments, seeds, and bulbs." }
        ]
      }
    ]
  },

];

export default function Evergreen() {
  return (
    <div className={styles.page}>

      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>News</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti News</span>
        <span className={styles["sep"]}>•</span>
        <span>January 7, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>4 Ways to Enjoy Evergreen Brick Works This Week!</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Evergreen Hero"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>A hidden gem in the heart of Toronto’s ravines, Evergreen Brick Works is a year-round destination where nature and community meet.</strong><br/>
        Open daily, it’s the perfect place to explore sustainable practices and connect with nature. In winter, enjoy free activities and experiences, making it a must-visit spot for everyone to embrace the beauty of the season.</p>
      </div>

      {MAPLE_SECTIONS.map((section, idx) => (
        <div key={idx}>
          <hr className={styles["region-divider"]} />
          
          {section.farms.map((farm, fIdx) => (
             <div key={fIdx} className={styles["farm-section"]}>
             <h3 className={styles["farm-name"]}>{farm.name}</h3>
             <hr className={styles["region-divider"]} />
             
             {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
             
             <div className={styles["farm-description"]}>
               <p><strong>{farm.subTitle}</strong></p>
               <p>{farm.description}</p>
             </div>

             <div className={styles["event-details-title"]}>Event Details:</div>
             <ul className={styles["details-list"]}>
               {farm.location && (
                 <li className={styles["details-item"]}>
                   <span className={styles["details-label"]}>Location:</span> {farm.location}
                 </li>
               )}
               {farm.website && (
                   <li className={styles["details-item"]}>
                   <span className={styles["details-label"]}>Website:</span><br />
                   <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                       {farm.website}
                   </a>
                   </li>
               )}
               {farm.details && farm.details.map((detail, dIdx) => {
                 const isHighlight = ["Festival Highlight", "Bonus Maple Treats Nearby!", "Seasonal Events", "What's included", "Important Notes"].includes(detail.label);
                 if (isHighlight) {
                   let contentItems = [];
                   if (detail.value.includes('|')) {
                     contentItems = detail.value.split('|').map(s => s.trim());
                   } else {
                     contentItems = [detail.value];
                   }

                   return (
                     <li key={dIdx} className={styles["highlight-detail"]}>
                       <span className={styles["highlight-label"]}>{detail.label}</span>
                       <div className={styles["highlight-content"]}>
                         <ul className={styles["highlight-list"]}>
                           {contentItems.map((item, i) => (
                             <li key={i}>{item}</li>
                           ))}
                         </ul>
                       </div>
                     </li>
                   );
                 }
                 return (
                   <li key={dIdx} className={styles["details-item"]}>
                     <span className={styles["details-label"]}>{detail.label}:</span> {detail.value}
                   </li>
                 );
               })}
             </ul>
             <hr className={styles["farm-divider"]} />
           </div>
          ))}
        </div>
      ))}
    </div>
  );
}
